import React from 'react';
import {Box, Link, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';

// A single quiet line: small, muted text with links that only underline on hover.
const linkSx = {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {color: 'primary.main', textDecoration: 'underline'},
};

const Dot = () => (
    <Box component="span" aria-hidden sx={{color: 'text.disabled'}}>·</Box>
);

const AppFooter = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                columnGap: 1.5,
                rowGap: 0.5,
                px: 3,
                py: 1.5,
                borderTop: 1,
                borderColor: 'divider',
            }}
        >
            <Typography variant="caption" color="text.secondary">
                Developed by Garrett Sato
            </Typography>
            <Dot/>
            <Typography variant="caption" color="text.secondary">
                <Link href="mailto:rogue.intuition.labs@gmail.com" sx={linkSx}>Contact</Link>
            </Typography>
            <Dot/>
            <Typography variant="caption" color="text.secondary">
                <Link component={RouterLink} to="/privacy" sx={linkSx}>Privacy</Link>
            </Typography>
            <Dot/>
            <Typography variant="caption" color="text.secondary">
                <Link
                    href="https://www.linkedin.com/in/garrett-sato-a8a65741/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={linkSx}
                >
                    LinkedIn
                </Link>
            </Typography>
        </Box>
    );
};

export default AppFooter;
